import { Box, Heading, Image, VStack } from '@chakra-ui/react';
import UIWidth from '../UIWidth';
import HeroBackgroundImage from './HeroBackgroundImage';

export default function HeroBanner({
  title,
  text = null,
  image,
  accentColor = null,
  textColor = null,
  picto = null,
  pictoMarginTop = null,
  pictoTopBase = null,
  pictoTopSm = null,
  pictoLeftBase = null,
  children = null,
  renderHeadingAs = "h1",
}) {
  return (
    <Box
      width="100%"
      backgroundColor={accentColor ? accentColor : 'brand.100'}
      color={textColor ? textColor : 'white'}
      position="relative"
      minHeight={{ md: '30rem' }}
      overflow="hidden"
    >
      <HeroBackgroundImage
        image={image}
        color={accentColor ? accentColor : 'brand.100'}
        picto={picto}
        pictoMarginTop={pictoMarginTop}
        pictoTopBase={pictoTopBase}
        pictoTopSm={pictoTopSm}
        pictoLeftBase={pictoLeftBase}
      />

      <UIWidth>
        <VStack
          justify={{ base: 'center' }}
          spacing={0}
          width={{ based: '100%', md: '50%' }}
          position="relative"
          zIndex={1}
          color={textColor ? textColor : 'white'}
          maxWidth={{ md: '50%' }}
          flexGrow={{ md: 1 }}
          flexShrink={{ md: 0 }}
          minHeight={{ md: '30rem' }}
        >
          <VStack
            alignSelf={{ md: 'stretch' }}
            justify={{ md: 'center' }}
            minHeight={{ md: '100%' }}
            flexGrow={{ md: 1 }}
          >
            <UIWidth isHalfForMd basePx="0" px="0">
              <Heading
                as={renderHeadingAs}
                variant="hero"
                color="inherit"
              >
                {title}
              </Heading>
              <Box
                my={{ base: '1em', md: '2rem' }}
                fontSize={['1.25rem', '', '1.5rem']}
                letterSpacing="-.125px"
                pb={{ sm: '1rem', md: 0 }}
                className="MYMYMY"
              >
                {text && text}
                {children && !text && children}
              </Box>
            </UIWidth>
          </VStack>
        </VStack>
      </UIWidth>
    </Box>
  );
}
